<template>
  <div v-if="text" :class="[classes]">
    {{ text }}
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  text: {
    type: String,
  },
  inline: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  parent: {
    type: Boolean,
    default: false,
  },
});

const classes = computed(() => {
  let classes = 'text-gray-400';
  if (props.disabled) {
    classes += ' text-gray-400/50';
  }
  if (props.parent) {
    classes += '  font-medium text-surface-400 tracking-wide';
    classes += props.disabled ? 'text-surface-400/50' : '';
  }
  return classes;
});
</script>
